var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 15.75,
    fill: "#F6EFFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7502 20.0995V21.902C29.7502 22.3833 29.3652 22.777 28.8752 22.7945H27.1602C26.2152 22.7945 25.3489 22.1033 25.2702 21.1583C25.2177 20.607 25.4277 20.0908 25.7952 19.732C26.1189 19.3995 26.5652 19.207 27.0552 19.207H28.8752C29.3652 19.2245 29.7502 19.6183 29.7502 20.0995Z",
    fill: "#A461D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5216 21.3002L23.5217 21.3008C23.6825 23.1305 25.2822 24.5437 27.16 24.5437H28.4112C28.4114 24.5437 28.4116 24.5438 28.4118 24.5438C28.3134 25.6074 27.8835 26.4628 27.2227 27.0537C26.5587 27.6475 25.6322 28 24.5 28H16.625C14.4516 28 12.6875 26.2359 12.6875 24.0625V17.9375C12.6875 16.8367 13.0182 15.9309 13.5794 15.2725C14.1396 14.6152 14.9529 14.1768 15.9707 14.0491L15.9707 14.0493L15.9828 14.0474C16.1869 14.016 16.4009 14 16.625 14H24.5C24.7185 14 24.9094 14.0086 25.0843 14.0378L25.0948 14.0395L25.1053 14.0408C26.9839 14.2609 28.2332 15.5407 28.4118 17.4562C28.4116 17.4562 28.4114 17.4562 28.4112 17.4562H27.055C26.1037 17.4562 25.212 17.8228 24.5666 18.4859C23.8099 19.2253 23.4318 20.2625 23.5216 21.3002ZM16.625 19.4687H21.875C22.4754 19.4687 22.9687 18.9754 22.9687 18.375C22.9687 17.7746 22.4754 17.2812 21.875 17.2812H16.625C16.0246 17.2812 15.5312 17.7746 15.5312 18.375C15.5312 18.9754 16.0246 19.4687 16.625 19.4687Z",
    fill: "#A461D8",
    stroke: "#A461D8",
    strokeWidth: 0.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet2);
export default __webpack_public_path__ + "static/media/wallet-2.98d74d9652550ef64345c7584cdc0597.svg";
export { ForwardRef as ReactComponent };